import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';
import { fadeIn } from '~src/styles/animations/animations.sc';
import { UnauthorizedPagesContainer } from '~src/outer_modules/shared/shared.sc';

import { FormTitle } from './shared.sc';

export const MoreInfoTxt = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  float: left;

  a {
    color: ${({ theme }) => theme.brandRed.a10};
  }
`;

export const LoginContainer = styled(UnauthorizedPagesContainer)<{ $full: boolean }>`
  ${({ $full }) => css`
    padding: 10rem 1.65rem;
    width: ${$full ? '100%' : '43%'};
    justify-content: ${$full ? 'center' : 'start'};
    transition: width 0.3s ease;
    ${media.desktop`
      width: 100%;
      justify-content: center;
      height: ${$full ? '100vh' : 'auto'};
      padding: 15px;
    `}
  `}
`;

export const FormContainer = styled.div`
  display: flex;
  width: 100%;
  justify-items: center;
  align-items: center;
  background-color: ${({ theme }) => theme.white.a10};
  height: auto;
  min-height: 100%;
  ${media.tablet`
    display: inline-block;
  `}
`;

export const InfoContent = styled.h2`
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-top: 40px;
  padding-right: 9rem;
  ${media.tablet`
    padding-right: 0;
  `}
`;

export const InfoGrid = styled.div`
  max-width: 739px;
  width: 100%;
  float: right;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 40px;
  ${media.desktop`
    margin-top: 70px;
  `}
  ${media.phone`
    padding-left: 0;
  `}
`;

export const InfoHeader = styled.h1`
  color: ${({ theme }) => theme.brandRed.a10};
  font-weight: 600;
  font-size: 48px;
  line-height: 54px;
  letter-spacing: 0.3px;
  padding-right: 8rem;
  ${media.tablet`
    padding-right: 0;
  `}
  ${media.phone`
    font-size: 35px;
    line-height: normal;
  `}
`;

export const LoginTitle = styled(FormTitle)`
  margin-bottom: 61px;
`;

export const LoginWrapper = styled.div`
  height: 100%;
`;

export const SignupInfoContainer = styled.div`
  width: 57%;
  height: 100%;
  margin-left: -57%;
  visibility: hidden;
  float: left;
  transition: margin-left 0.3s ease;
  ${media.tablet`
    width: 100%;
    height: auto;
    display: none;
    padding: 3rem;
  `}

  &.visible {
    margin-left: 0;
    visibility: visible;
    ${media.tablet`
      display: block;
    `}
  }

  ${media.phone`
    padding: 30px;
  `}
`;

export const SignUpGrid = styled.div`
  margin: 0;
  animation: ${fadeIn} 0.3s ease;
  align-self: center;
  padding: 2rem;
  ${media.phone`
    padding: 0;
  `}
`;

export const LoginGrid = styled.div`
  min-width: 359px;
  align-self: center;
  max-width: ${({ theme }) => theme.sz.pageContentWidth};
  animation: ${fadeIn} 0.3s ease;
  ${media.phone`
    min-width: 100%;
  `}
`;
